<template>
  <div class="inputDiv"
       :id="'inputDiv'+index+subIndex"
       :contenteditable="contenteditable"
       @blur="changeValue"
       :style="{'background':contenteditable?'transparent':'#f7f7f7'}"
  >{{ value }}
  </div>
</template>

<script>
export default {
  name: 'inputDiv',
  props: ['value', 'index', 'subIndex', 'contenteditable'],
  methods: {
    replaceText(val) {
      if (val != null && val != "") {
        var re1 = new RegExp("<.+?>|&.+?;","g");
        var msg = val.replace(re1,"");
        msg = msg.replace(/\s/g,"");
        msg = msg.replace(/[\r\n]/g,"");
        return msg
      } else return ''
    },
    changeValue() {
      let option = {
        value: this.replaceText(this.$el.innerHTML),
        index: this.index,
        subIndex: this.subIndex,
        divID: 'inputDiv' + this.index + this.subIndex
      }
      this.$emit('inputValue', option)
    }
  }
}
</script>
